export interface BpmnTranslate {
  [key: string]: string;
}

// const palette: BpmnTranslate = {
//   Name: "Nome",
//   General: "Geral",
//   Documentation: "Documentação",
//   "Element Documentation": "Elemento de documentação",
//   Form: "Formulário",
// };

const modeler: BpmnTranslate = {
  // Labels
  "Activate the global connect tool": "Activar herramienta de conexión global",
  "Append {type}": "Adjuntar {type}",
  "Add Lane above": "Añadir vía anterior",
  "Divide into two Lanes": "Dividir en dos vías",
  "Divide into three Lanes": "Dividir en tres vías",
  "Add Lane below": "Añadir vía a continuación",
  "Append compensation activity": "Adjuntar actividad de compensación",
  "Append Intermediate/Boundary Event": "Adjuntar evento intermediario/frontera",
  "Append Gateway": "Adjuntar Gateway",
  "Append UserTask": "Adjuntar tarea de usuario",
  "Append ServiceTask": "Adjuntar tarea de servicio",
  "Append TextAnnotation": "Adjuntar anotación de texto",
  "Change type": "Cambiar tipo",
  "Connect using Association": "Conectar usando asociación",
  "Connect using Sequence/MessageFlow or Association": "Conectar usando Secuencia/Flujo de Mensaje o Asociación",
  "Connect using DataInputAssociation": "Conectar usando Entrada de Datos de Asociación",
  Remove: "Eliminar",
  "Activate the hand tool": "Activar herramienta de mano",
  "Activate the lasso tool": "Activar herramienta de lazo",
  "Activate the create/remove space tool": "Activar añadir/eliminar herramienta espacial",
  "Create expanded SubProcess": "Crear subproceso expandido",
  "Create Intermediate/Boundary Event": "Crear evento intermediario/límite",
  "Create Pool/Participant": "Crear Pool / Participante",
  "Create Start Timer Event": "Crear evento de inicio de tiempo",
  "Create StartEvent": "Crear evento de inicio",
  "Create EndEvent": "Crear evento de finalización",
  "Create Gateway": "Crear Gateway",
  "Create Task": "Crear tarea",
  "Create DataObjectReference": "Crear DataObjectReference",
  "Create DataStoreReference": "Crear DataStoreReference",
  "Create Group": "Crear grupo",
  "Create UserTask": "Crear tarea de usuario",
  "Create ServiceTask": "Crear tarea de servicio",
  "Append EndEvent": "Adjuntar evento de finalización",
  "Append Task": "Adjuntar tarea",
  "Parallel Multi Instance": "Instancia Multiparalela",
  "Sequential Multi Instance": "Instancia Multisecuencial",
  Loop: "Loop",
  "Ad-hoc": "Ad-hoc",
  "Create {type}": "Crear {type}",
  Task: "Tarea",
  "Send Task": "Enviar Tarea",
  "Receive Task": "Tarea de Recibo",
  "User Task": "Tarea de Usuario",
  "Manual Task": "Tarea Manual",
  "Business Rule Task": "Tarea de Regla de Negocio",
  "Service Task": "Tarea del tipo Servicio",
  "Script Task": "Tarea de Rotero",
  "Call Activity": "Actividad de Conectar",
  "Sub Process (collapsed)": "Subproceso (agrupado)",
  "Start Event": "Evento de inicio",
  "Intermediate Throw Event": "Evento Intermediario",
  "End Event": "Evento de finalización",
  "Message Start Event": "Evento de Inicio de Mensaje",
  "Timer Start Event": "Evento de Inicio de Timer",
  "Conditional Start Event": "Evento de Inicio Condicional",
  "Signal Start Event": "Evento de inicio de señal",
  "Error Start Event": "Evento de inicio de error",
  "Escalation Start Event": "Evento inicial de escalonamiento",
  "Compensation Start Event": "Evento de Inicio de la Compensación",
  "Message Start Event (non-interrupting)": "Evento de Inicio de Mensaje (sin interrupción)",
  "Timer Start Event (non-interrupting)": "Evento de Inicio del Timer (sin interrupción)",
  "Conditional Start Event (non-interrupting)": "Evento de Inicio Condicional (sin interrupción)",
  "Signal Start Event (non-interrupting)": "Evento de inicio de señal (sin interrupción)",
  "Escalation Start Event (non-interrupting)": "Evento inicial de escaloniamento (sin interrupción)",
  "Message Intermediate Catch Event": "Evento de Captura Intermediario de Mensaje",
  "Message Intermediate Throw Event": "Evento de Registro Intermediario de Mensaje",
  "Timer Intermediate Catch Event": "Evento de Captura Intermediario de Temporizador",
  "Escalation Intermediate Throw Event": "Evento de Registro Intermediario de Escalonamiento",
  "Conditional Intermediate Catch Event": "Evento de Captura Intermediario Condicional",
  "Link Intermediate Catch Event": "Evento de Captura Intermediario de Link",
  "Link Intermediate Throw Event": "Evento de registro Intermediario de Link",
  "Compensation Intermediate Throw Event": "Evento de Registro Intermediario de Compensación",
  "Signal Intermediate Catch Event": "Evento de Captura Intermediario de Señal",
  "Signal Intermediate Throw Event": "Evento de Registro Intermediario de Señal",
  "Message End Event": "Evento de final del mensaje",
  "Escalation End Event": "Evento Final de Escalonamiento",
  "Error End Event": "Evento Final del Error",
  "Cancel End Event": "Cancelar evento final",
  "Compensation End Event": "Evento de Fin de Compensación",
  "Signal End Event": "Evento Final del señal",
  "Terminate End Event": "Terminate End Event",
  "Message Boundary Event": "Evento de mensaje de Frontera",
  "Message Boundary Event (non-interrupting)": "Evento de Mensaje de Frontera (sin interrupción)",
  "Timer Boundary Event": "Evento de Límite de Temporarizador",
  "Timer Boundary Event (non-interrupting)": "Evento de Límite de Temporarizador (sin interrupción)",
  "Escalation Boundary Event": "Evento de límite de escalonamiento",
  "Escalation Boundary Event (non-interrupting)": "Evento de límite de escalonamiento (sin interrupción)",
  "Conditional Boundary Event": "Evento de límite condicional",
  "Conditional Boundary Event (non-interrupting)": "Evento de límite condicional (sin interrupción)",
  "Error Boundary Event": "Evento de límite de error",
  "Cancel Boundary Event": "Cancelar evento de límite",
  "Signal Boundary Event": "Evento de límite de señal",
  "Signal Boundary Event (non-interrupting)": "Evento de límite de señal (sin interrupción)",
  "Compensation Boundary Event": "Evento de Límite de Compensación",
  "Exclusive Gateway": "Gateway Exclusivo",
  "Parallel Gateway": "Gateway Paralelo",
  "Inclusive Gateway": "Gateway Inclusivo",
  "Complex Gateway": "Gateway Complejo",
  "Event based Gateway": "Gateway basado en eventos",
  Transaction: "Transacción",
  "Sub Process": "Subproceso",
  "Event Sub Process": "Evento de subproceso",
  "Collapsed Pool": "Pool cerrado",
  "Expanded Pool": "Pool expandido",

  // Errors
  "no parent for {element} in {parent}": "sin elemento principal para {element} en {parent}",
  "no shape type specified": "tipo de forma no especificado",
  "flow elements must be children of pools/participants": "elementos flow deben ser hijos de pools/participantes",
  "out of bounds release": "release fuera de los límites",
  "more than {count} child lanes": "más de {count} rangos hijos",
  "element required": "elemento requerido",
  "diagram not part of bpmn:Definitions": "diagrama no atiende as bpmn:Definitions",
  "no diagram to display": "sin diagrama para presentar",
  "no process or collaboration to display": "sin procesos o colaboración por presentar",
  "element {element} referenced by {referenced}#{property} not yet drawn":
    "elemento {element} referenciado por {referenced}#{property} no está lista para diseñar",
  "already rendered {element}": "{element} ya renderizado",
  "failed to import {element}": "error en la importación de {element}",
};

const fullI18n = {
  // ...palette,
  ...modeler,
};

export default fullI18n;
